import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 17.063C4.554 17.063.938 13.446.938 9S4.554.938 9 .938 17.063 4.554 17.063 9 13.446 17.063 9 17.063m0-15A6.945 6.945 0 0 0 2.063 9 6.945 6.945 0 0 0 9 15.938 6.945 6.945 0 0 0 15.938 9 6.945 6.945 0 0 0 9 2.063m.563 10.312V8.947a.563.563 0 0 0-1.126 0v3.428a.563.563 0 0 0 1.126 0m.202-6a.75.75 0 0 0-.75-.75h-.007a.747.747 0 0 0-.747.75c0 .414.34.75.754.75a.75.75 0 0 0 .75-.75"
    }, null, -1)
  ])))
}
export default { render: render }